module.exports = __webpack_public_path__ + "media/images/lb/193-61f3b51b9d66b2291bd373296590a2f2.svg";